import { render, staticRenderFns } from "./workMaterial.vue?vue&type=template&id=184a3ae8&scoped=true&"
import script from "./workMaterial.vue?vue&type=script&lang=js&"
export * from "./workMaterial.vue?vue&type=script&lang=js&"
import style0 from "./workMaterial.vue?vue&type=style&index=0&id=184a3ae8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a3ae8",
  null
  
)

export default component.exports